import React, { useRef, useEffect, useState } from 'react';
import "./mobilecontrols.css"
import { useTranslation } from 'react-i18next';

interface MobileControlsProps {
    setMobileMenuActive: (active: number) => void;
    mobileMenuActive: number;
    isMobile: boolean;
}

const MobileControls: React.FC<MobileControlsProps> = ({
    setMobileMenuActive,
    mobileMenuActive,
    isMobile
}) => {
const { t, i18n } = useTranslation();

    return (
        <div className="sc-4dc8dba4-0 fyVfpd" style={{ display: isMobile ? "flex" : "none" }}>
            <div className="sc-aa05954f-0 bmXest">
                <div className="sc-aa05954f-3 gnIWBN">
                    <div className="sc-4dc8dba4-3 kvGauR">
                        <button className={`sc-4dc8dba4-4 ${mobileMenuActive === 0 ? "fqStRZ" : "hLWJVw"}`} onClick={() => setMobileMenuActive(0)}>{t("mobile_controls.actions")}</button>
                        <button className={`sc-4dc8dba4-4 ${mobileMenuActive === 1 ? "fqStRZ" : "hLWJVw"}`} onClick={() => setMobileMenuActive(1)}>{t("mobile_controls.stats")}</button>
                        <button className={`sc-4dc8dba4-4 ${mobileMenuActive === 2 ? "fqStRZ" : "hLWJVw"}`} onClick={() => setMobileMenuActive(2)}>{t("mobile_controls.milking")}</button>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default MobileControls;
